import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ColissessionService } from '../colissession/colissession.service';
import { VoyageService } from '../voyage/voyage.service';
import { CollisService } from '../collis/collis.service';
import { BagageService } from '../bagage/bagage.service';
import { RecetteService } from '../recette/recette.service';
import { SessionPrintService } from '../print/session-print.service';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class SessionCloseService {
  constructor(
    private router: Router,
    private sessionservice: ColissessionService,
    private voyageservice: VoyageService,
    private collisservice: CollisService,
    private bagageservice: BagageService,
    private recetteservice: RecetteService,
    private sessionPrintService: SessionPrintService
  ) {}

  public closeSession(session: any, name: string, base64: string): void {
    if (!session || session === 'null' || String(session).trim() === '') {
      this.executeLogout();
      return;
    }
    this.sessionservice.getsessiondetail(session).subscribe(
      (response: any) => {
        const sessiondetail = response;
        setTimeout(() => {
          if (localStorage.getItem('section') == 'envoi') {
            this.getCollisSessionSummary(session, sessiondetail, name, base64);
          }
          if (localStorage.getItem('section') == 'guichet') {
            this.getpassagerSessionSummary(session, sessiondetail, name, base64);
          }
          if (localStorage.getItem('section') != 'guichet' && localStorage.getItem('section') != 'envoi') {
            setTimeout(() => {
              this.executeLogout();
            }, 700);
          }
        }, 500);
      },
      (error: any) => {
        console.error('Failed to get session details', error);
        Swal.fire({
          title: 'Erreur',
          text: 'Impossible de récupérer les détails de la session.',
          icon: 'error',
          confirmButtonText: 'OK'
        }).then(() => {
          this.executeLogout();
        });
      }
    );
  }

  private getpassagerSessionSummary(session: any, sessiondetail: any, name: string, base64: string): void {
    const payload = {
      idsessiion: session,
      sessionCount: sessiondetail.sessionCount,
      name: name,
      sessionAmount: sessiondetail.sessionAmount,
      creationDate: sessiondetail.creationDate,
      closingDate: sessiondetail.closingDate || new Date()
    };
    this.sessionPrintService.printPassagerSession(payload).then(() => {
      this.executeLogout();
    }).catch((error: any) => {
        console.error('Failed to get passenger session summary', error);
        Swal.fire({
          title: 'Erreur',
          text: 'Impossible de générer le rapport de session passager.',
          icon: 'error',
          confirmButtonText: 'OK'
        }).then(() => {
          this.executeLogout();
        });
      }
    );
  }

  private getCollisSessionSummary(session: any, sessiondetail: any, name: string, base64: string): void {
    const payload = {
      idsessiion: session,
      sessionCount: sessiondetail.sessionCount,
      name: name,
      sessionAmount: sessiondetail.sessionAmount,
      creationDate: sessiondetail.creationDate,
      closingDate: sessiondetail.closingDate || new Date()
    };
    this.sessionPrintService.printMixedSessionSummary(payload).then(() => {
      this.executeLogout();
    }).catch((error: any) => {
      console.error('Failed to generate session summary', error);
      Swal.fire({
        title: 'Erreur',
        text: 'Impossible de générer le rapport de session.',
        icon: 'error',
        confirmButtonText: 'OK'
      }).then(() => {
        this.executeLogout();
      });
    });
  }

  private executeLogout(): void {
    localStorage.removeItem('userinfo');
    localStorage.removeItem('token');
    localStorage.removeItem('loggedInUser');
    localStorage.removeItem('userRole');
    localStorage.removeItem('agenceinso');
    localStorage.removeItem('agence');
    localStorage.removeItem('authority');
    localStorage.removeItem('section');
    localStorage.removeItem('lastprint');
    localStorage.removeItem('voyage');
    localStorage.removeItem('session');
    this.router.navigateByUrl('login');
    localStorage.removeItem('session');
    localStorage.clear();
  }
}
